module.exports = __webpack_public_path__ + "img/unitTest.00a4e1ea.png";